import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { ReminderModalsActions } from 'app/modules/reminder/modals/state/reminderModalsActions';
import { ReminderModalsSelectors } from 'app/modules/reminder/modals/state/reminderModalsSelectors';

export const CREATE_REMINDER_MODAL_QUERY_PARAM = 'reminder';

/**
 * Opens the create reminder modal when the URL contains `?reminder=true`.
 * Keeps the query param while the modal is open and removes it when the modal closes.
 */
export const useOpenCreateReminderModalFromUrl = (): void => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const isVisible = useSelector(ReminderModalsSelectors.selectIsReminderCreateModalVisible);
  const shouldOpenReminderModal = searchParams.get(CREATE_REMINDER_MODAL_QUERY_PARAM) === 'true';
  const wasVisibleRef = useRef(false);

  useEffect(() => {
    const wasVisible = wasVisibleRef.current;

    if (wasVisible && !isVisible && shouldOpenReminderModal) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete(CREATE_REMINDER_MODAL_QUERY_PARAM);
      setSearchParams(nextParams, { replace: true });
      wasVisibleRef.current = false;
      return;
    }

    if (shouldOpenReminderModal && !isVisible && !wasVisible) {
      dispatch(ReminderModalsActions.showReminderCreateModal());
    }

    wasVisibleRef.current = isVisible;
  }, [dispatch, isVisible, searchParams, setSearchParams, shouldOpenReminderModal]);
};
